(function($) {
    $(window).load( function() {
        if (window.articleAnalytics) {
            // convert id string to int
            articleAnalytics.content_id = parseInt(articleAnalytics.content_id)
            CSAnalytics("Content Read", articleAnalytics)
        }
    })
})(jQuery);
